export default {
  setBilling(state: any, payload:Billing.Subscription) {
    state.billing = payload
  },
  setBillingPlans(state: any, payload: Billing.BillingPlan[]) {
    state.billingPlans = payload;
  },
  setBillingCustomer(state: any, payload: Billing.BillingCustomer) {
    state.billingCustomer = payload;
  },
  setBillingAddons(state: any, payload: Billing.BillingAddon[]) {
    state.billingAddons = payload.reduce((acc,addon)=>{
      acc[addon.id] = addon;
      return acc
    },{});
  },
};
